<template>
  <div class="wrapper">
    <div class="text-center">
      <p class="text-h4 mt-6 mb-4 primary-color">
        Search for Courses & Jobs in the ALLVIEW Platform
      </p>
    </div>
    <div>
      <p class="text-h5 font-weight-black section-heading">Top Rated Courses</p>
      <v-row class="mb-0">
        <v-col
          xl="3"
          lg="3"
          md="3"
          sm="6"
          xs="6"
          class="d-flex"
          v-for="course in topRatedCourses"
          :key="course.course_id"
        >
          <course-card
            :course="course"
            :to="'/app/people/course/' + course.course_id"
          />
        </v-col>
      </v-row>
      <v-list class="center-list">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Explore all the courses</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <router-link to="/app/people/search-courses" class="no-link">
              <v-icon color="primary"> mdi-arrow-right-circle </v-icon>
            </router-link>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
      <br /><br />
      <p class="text-h5 font-weight-black section-heading">Recommended Courses For You</p>
      <v-row class="mb-0">
        <v-col
          xl="3"
          lg="3"
          md="3"
          sm="6"
          xs="6"
          class="d-flex"
          v-for="course in recommendedCourses"
          :key="course.course_id"
        >
          <course-card
            :course="course"
            outlined
            :to="'/app/people/course/' + course.course_id"
          />
        </v-col>
      </v-row>
      <v-list class="center-list">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Explore All The Courses</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <router-link to="/app/people/search-courses" class="no-link">
              <v-icon color="primary"> mdi-arrow-right-circle </v-icon>
            </router-link>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
      <br /><br />
      <p class="text-h5 font-weight-black">New Jobs</p>
      <v-row class="mb-0">
        <v-col
          xl="3"
          lg="3"
          md="3"
          sm="6"
          xs="6"
          class="d-flex"
          v-for="job in newJobs"
          :key="job.job_id"
        >
          <job-card
            :job="job"
            :to="'/app/people/job/' + job.job_id"
          />
        </v-col>
      </v-row>
      <v-list class="center-list">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Explore all the jobs</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <router-link to="/app/people/search-jobs" class="no-link">
              <v-icon color="primary"> mdi-arrow-right-circle </v-icon>
            </router-link>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
      <br /><br />
      <p class="text-h5 font-weight-black">Recommended Jobs For You</p>
      <v-row class="mb-0">
        <v-col
          xl="3"
          lg="3"
          md="3"
          sm="6"
          xs="6"
          class="d-flex"
          v-for="job in recommendedJobs"
          :key="job.job_id"
        >
          <job-card
            :job="job"
            outlined
            :to="'/app/people/job/' + job.job_id"
          />
        </v-col>
      </v-row>
      <v-list class="center-list">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Explore all the jobs</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <router-link to="/app/people/search-jobs" class="no-link">
              <v-icon color="primary"> mdi-arrow-right-circle </v-icon>
            </router-link>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
      <br /><br />
      <br /><br />
    </div>
  </div>
</template>

<script>
import CourseCard from "@/components/CourseCard.vue";
import JobCard from "@/components/JobCard.vue";
const { browserLang } = require("../../../lib/catalog-autocomplete");
export default {
  name: "Home",
  components: { CourseCard, JobCard },

  data: () => ({
    topRatedCourses: [],
    recommendedCourses: [],
    newJobs: [],
    recommendedJobs: [],
    // env
    VUE_APP_API_ENDPOINT: process.env.VUE_APP_API_ENDPOINT,
  }),
  async mounted() {
    try {
      await this.getData();
    } catch (error) {
      if (error.message.includes("Authentication failed")) {
        this.$router.push("/auth-error");
      }
    }
  },
  methods: {
    async getData() {
      let response = await fetch(
        process.env.VUE_APP_API_ENDPOINT + "people/home",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Auth-Token": this.$cookie.get("jwt_token"),
            "Accept-Language": browserLang(),
          },
        }
      );
      response = await response.json();
      if (response.success) {
        this.topRatedCourses = response.result.topRatedCourses;
        this.recommendedCourses = response.result.recommendedCourses;
        this.newJobs = response.result.newJobs;
        this.recommendedJobs = response.result.recommendedJobs;
        this.$emit('missingProfile', response.result.missingProfile)
      } else {
        throw new Error(response.message);
      }
    },
  },
};
</script>

<style scoped>
.centertext {
  margin-left: auto;
  margin-right: auto;
}
.no-link {
  text-decoration: none;
  color: black;
}
.card-title {
  text-transform: capitalize;
  word-break: normal;
}
.primary-color {
  color: #0096c7;
}
.section-heading {
  margin-bottom: 26px;
}
.center-list {
  max-width: 240px;
  margin: 0 auto;
}

.wrapper {
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 40px;
}
.rec-explanation {
  font-size: 13px;
  line-height: 1.35;
  color: #444;
  font-style: italic;
}
</style>
